import {useQuery} from 'react-query'
import {RequestEditModalForm} from './RequestEditModalForm'
// import {isNotEmpty, QUERIES} from '../../../../../../_metronic/helpers'
import {useListView} from '../core/ListViewProvider'
import {getRequestById} from '../core/_requests'
import { QUERIES, isNotEmpty } from '../../../../../_metronic/helpers'

const RequestEditModalFormWrapper = () => {
  const {itemIdForUpdate, setItemIdForUpdate} = useListView()
  const enabledQuery: boolean = isNotEmpty(itemIdForUpdate)
  const dataresponse = {name:"demo"}
  const {
    isLoading,
    data: request,
    error,
  } = useQuery(
    `${QUERIES.REQUESTS_LIST}-request-${itemIdForUpdate}`,
    () => {
      return getRequestById(itemIdForUpdate)
    },
    {
      cacheTime: 0,
      enabled: enabledQuery,
      onError: (err) => {
        // setItemIdForUpdate(undefined)
        console.error(err)
      },
    }
  )


  if (!itemIdForUpdate) {
    return <RequestEditModalForm isRequestLoading={false} request={{id: undefined}} />
  }

  if (itemIdForUpdate) {
    return <RequestEditModalForm isRequestLoading={false} request={dataresponse} />
  }

  return null
}

export {RequestEditModalFormWrapper}
